import React, { useState } from 'react';

const TaskForm = ({ onAddTask }) => {
  const [newTaskText, setNewTaskText] = useState('');

  const handleSubmit = (e, important = false) => {
    e.preventDefault();
    if (newTaskText.trim() === '') return;
    onAddTask(newTaskText, important);
    setNewTaskText('');
  };

  return (
    <form className="task-form" onSubmit={(e) => handleSubmit(e, false)}>
      <div className="task-input-group">
        <input
          type="text"
          value={newTaskText}
          onChange={(e) => setNewTaskText(e.target.value)}
          placeholder="Afegeix una nova tasca..."
        />
        <button type="submit">Afegir</button>
      </div>

      <button
        type="button"
        className="important-btn"
        onClick={(e) => handleSubmit(e, true)}
      >
        Tasca Important
      </button>
    </form>
  );
};

export default TaskForm;
